import React, { useState, useEffect } from 'react';
import { useWeb3React } from '@web3-react/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusSquare, faPlusSquare } from '@fortawesome/free-solid-svg-icons';
import { getBalancePublicPrice, mint, getRound } from '../../../utils/callNFKeyContract';
import { KALAO_LINK } from '../../../constants';
import { NFTRADE_LINK } from '../../../constants';
import LamboReveal from '../../../assets/video/LamboReveal.mp4';
import Trophy from '../../../assets/images/trophy_2.png';
import Profit from '../../../assets/images/profit.png';
import Gift from '../../../assets/images/gift.png';
import Finish from '../../../assets/images/finish.png';
import Racex from '../../../assets/images/racex.png';
import Kalao from '../../../assets/images/kalao.png';
import Nftrade from '../../../assets/images/nftrade.png';
import './MintYourRaceCar.css';

const MintYourRaceCar = () => {
  const { account, activate, chainId } = useWeb3React();
  const [amount, setAmount] = useState(1)
  const [publicPrice, setPublicPrice] = useState(0)
  const [round, setRound] = useState(1)

  useEffect(() => {
    const getPrice = async () => {
      const { price } = await getBalancePublicPrice(account)
      setPublicPrice(price)
    }
    const getRoundNumber = async () => {
      const round = await getRound()
      setRound(round)
    }
    account && getPrice()
    account && getRoundNumber()
  }, [account, chainId])

  const onChangeAmount = (val) => {
    if (20 < val || val < 1 || val.toString().includes('.')) return
    setAmount(val)
  }
  const onClickMint = () => {
    const _res = mint(account, amount, account)
  }

  return (
    <div className='mintYourRaceCar' id='mint'>
      <label className='mintYourRaceCar__title'>
        MINT your RaceCar NFT !
      </label>
      <label className='mintYourRaceCar__description'>
        Different levels of discount will be applied depending the amount of $RaceX in your Wallet! <br/>
        See informations below.
      </label>

      <div className='mintYourRaceCar__mint'>
        <div className='mintYourRaceCar__mint__box__desk'>
          <label className='mintYourRaceCar__mint__round'>Round {round.round}/4</label>
          <label className='mintYourRaceCar__mint__tokens'>{round.tokensMinted}/{round.maxSupply}</label>
          <label>Select the amout of NFT to Mint</label>
          <div className='mintYourRaceCar__mint__input__box'>
            <FontAwesomeIcon icon={faMinusSquare} className='mintYourRaceCar__mint__icon' onClick={()=>onChangeAmount(amount-1)} />
            <input type='number' min="1" step="1" className='mintYourRaceCar__mint__input' value={amount} onChange={e=>onChangeAmount(e.target.value)}/>
            <FontAwesomeIcon icon={faPlusSquare} className='mintYourRaceCar__mint__icon' onClick={()=>onChangeAmount(amount+1)} />
          </div>
          <label className='mintYourRaceCar__mint__title'>Total: {publicPrice * amount} AVAX</label>
          <button className='mintYourRaceCar__mint__submit' onClick={onClickMint}>
            Mint !
          </button>
        </div>
        <video src={LamboReveal} type='video/mp4' className='mintYourRaceCar__mint__video__desk' autoPlay muted/>
        <div className='mintYourRaceCar__mint__list__desk'>
          <div className='mintYourRaceCar__mint__item'>
            <img src={Profit} className='mintYourRaceCar__mint__item__img' alt=''/>
            <label className='mintYourRaceCar__mint__item__text'>NFT holders will share 3% reflexion on all sales (minting and secondary)</label>
          </div>
          <div className='mintYourRaceCar__mint__item'>
            <img src={Gift} className='mintYourRaceCar__mint__item__img' alt=''/>
            <label className='mintYourRaceCar__mint__item__text'>Free Mint for holders of our NFKEY released during presale</label>
          </div>
          <div className='mintYourRaceCar__mint__item'>
            <img src={Trophy} className='mintYourRaceCar__mint__item__img' alt=''/>
            <label className='mintYourRaceCar__mint__item__text'>Limited supply : only 10.000 RaceCars are available for minting</label>
          </div>
        </div>

        <video src={LamboReveal} type='video/mp4' className='mintYourRaceCar__mint__video__mobile' autoPlay muted/>
        <div className='mintYourRaceCar__mint__list__mobile'>
          <div className='mintYourRaceCar__mint__item'>
            <img src={Profit} className='mintYourRaceCar__mint__item__img' alt=''/>
            <label className='mintYourRaceCar__mint__item__text'>NFT holders will share 3% reflexion on all sales (minting and secondary)</label>
          </div>
          <div className='mintYourRaceCar__mint__item'>
            <img src={Gift} className='mintYourRaceCar__mint__item__img' alt=''/>
            <label className='mintYourRaceCar__mint__item__text'>Free Mint for holders of our NFKEY released during presale</label>
          </div>
          <div className='mintYourRaceCar__mint__item'>
            <img src={Trophy} className='mintYourRaceCar__mint__item__img' alt=''/>
            <label className='mintYourRaceCar__mint__item__text'>Limited supply : only 10.000 RaceCars are available for minting</label>
          </div>
        </div>
        <div className='mintYourRaceCar__mint__box__mobile'>
          <label className='mintYourRaceCar__mint__round'>Round 1/4</label>
          <label className='mintYourRaceCar__mint__tokens'>{round.tokensMinted}/{round.maxSupply}</label>
          <label>Select the amout of NFT to Mint</label>
          <div className='mintYourRaceCar__mint__input__box'>
            <FontAwesomeIcon icon={faMinusSquare} className='mintYourRaceCar__mint__icon' onClick={()=>onChangeAmount(amount-1)}/>
            <input type='number' className='mintYourRaceCar__mint__input' value={amount} onChange={e=>onChangeAmount(e.target.value)} />
            <FontAwesomeIcon icon={faPlusSquare} className='mintYourRaceCar__mint__icon' onClick={()=>onChangeAmount(amount+1)}/>
          </div>
          <label className='mintYourRaceCar__mint__title'>Total: {publicPrice * amount} AVAX</label>
          <button className='mintYourRaceCar__mint__submit' onClick={onClickMint}>
            Mint !
          </button>
        </div>

      </div>

      <div className='mintYourRaceCar__info__box'>
        <div className='mintYourRaceCar__info'>
          <div className='mintYourRaceCar__info__title__box'>
            <img src={Finish} className='mintYourRaceCar__mint__item__img' alt=''/>
            <label>Round informations and prices</label>
          </div>
          <div className='mintYourRaceCar__info__item'>
            <label>1st car to 1745th: this round is only for NFKEY owners</label>
          </div>
          <div className='mintYourRaceCar__info__item'>
            <label>1745th to 6000th: price before discounts will be 3 $AVAX</label>
          </div>
          <div className='mintYourRaceCar__info__item'>
            <label>6000th to 8000th: price before discounts will be 3,5 $AVAX</label>
          </div>
          <div className='mintYourRaceCar__info__item'>
            <label>8000th to last car: price before discounts will be 4 $AVAX</label>
          </div>
        </div>

        <div className='mintYourRaceCar__info'>
          <div className='mintYourRaceCar__info__title__box'>
            <img src={Racex} className='mintYourRaceCar__mint__item__img' alt=''/>
            <label>Discounts for $RaceX Holders</label>
          </div>
          <div className='mintYourRaceCar__info__item' style={{background:'linear-gradient(to right, #523314, #CD7F32)'}}>
            <label>&lsaquo; 500.000 $RaceX tokens: -10%</label>
          </div>
          <div className='mintYourRaceCar__info__item' style={{background:'linear-gradient(to right, #98720B, #F6D56D)'}}>
            <label>&rsaquo; 1.000.000 $RaceX tokens: -22%</label>
          </div>
          <div className='mintYourRaceCar__info__item' style={{background:'linear-gradient(to right, #4D4D4D, #C5BDBD)'}}>
            <label>&rsaquo; 500.000 $RaceX tokens: -15%</label>
          </div>
          <div className='mintYourRaceCar__info__item__nfKey'>
            <label>NFKey and $RaceX token holders: -25%</label>
          </div>
        </div>
      </div>

      <div className='mintYourRaceCar__kalao'>
        <label>You can also find our cars on the secondary marketplaces</label>
        <a href={KALAO_LINK} className='mintYourRaceCar__kalao__link' target='_blank'>
          <img src={Kalao} style={{width:'100%', height:'100%'}} alt=''/>
        </a>
        <a href={NFTRADE_LINK} className='mintYourRaceCar__nftrade__link' target='_blank'>
          <img src={Nftrade} style={{width:'100%', height:'100%'}} alt=''/>
        </a>
      </div>

    </div>
   ) 
}

export default MintYourRaceCar;